import { Button, Modal, Space, theme } from "antd";
import {
  ReloadOutlined,
  RocketOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { memo, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import useAppUpdate from "hooks/useAppUpdate";

// Notifikasi versi baru. "Nanti Saja" hanya menutup notifikasi (versi lama tetap
// dipakai); notifikasi tampil lagi setiap pindah halaman selama versi baru belum terpasang.
const UpdateAppWrapper = () => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const [modal, modalContextHolder] = Modal.useModal();
  const { updateAvailable, isSafeToReload, pathname, onReloadPage } =
    useAppUpdate();
  const [dismissedPathname, setDismissedPathname] = useState(null);

  const laterHandler = useCallback(() => {
    setDismissedPathname(pathname);
  }, [pathname]);

  // Di halaman form / saat ada draft chat, muat ulang bisa menghapus data — minta konfirmasi dulu
  const reloadHandler = useCallback(() => {
    if (isSafeToReload) {
      onReloadPage();
      return;
    }

    modal.confirm({
      title: t("notification.update_confirm_title"),
      content: t("notification.update_confirm_content"),
      okText: t("notification.update_confirm_ok"),
      okButtonProps: { danger: true },
      cancelText: t("button.cancel"),
      onOk: onReloadPage,
    });
  }, [isSafeToReload, modal, onReloadPage, t]);

  const visible = updateAvailable && dismissedPathname !== pathname;

  return (
    <>
      {modalContextHolder}
      {visible && (
        <div
          className="hide-on-print fixed bottom-4 left-4 right-4 sm:left-auto sm:w-[380px] rounded-lg p-4"
          style={{
            zIndex: 1010,
            background: token.colorBgElevated,
            boxShadow: token.boxShadowSecondary,
          }}
        >
          <div className="flex items-start gap-3">
            <span
              className="flex shrink-0 items-center justify-center w-9 h-9 rounded-full text-base"
              style={{
                background: token.colorPrimaryBg,
                color: token.colorPrimary,
              }}
            >
              <RocketOutlined />
            </span>
            <div className="flex-1 min-w-0">
              <div
                className="font-semibold"
                style={{ color: token.colorTextHeading }}
              >
                {t("notification.a_new_version_is_available")}
              </div>
              <div
                className="mt-1 text-sm"
                style={{ color: token.colorTextSecondary }}
              >
                {t(
                  isSafeToReload
                    ? "notification.update_description"
                    : "notification.update_description_draft",
                )}
              </div>
              {!isSafeToReload && (
                <div
                  className="flex items-center gap-2 mt-2 px-2 py-1 rounded text-xs"
                  style={{
                    background: token.colorSuccessBg,
                    color: token.colorSuccessText,
                  }}
                >
                  <SafetyCertificateOutlined />
                  <span>{t("notification.update_data_safe")}</span>
                </div>
              )}
            </div>
          </div>
          <div className="flex justify-end mt-3">
            <Space size={8}>
              <Button type="text" size="small" onClick={laterHandler}>
                {t("notification.later")}
              </Button>
              <Button
                type="primary"
                size="small"
                icon={<ReloadOutlined />}
                onClick={reloadHandler}
              >
                {t("notification.update_reload")}
              </Button>
            </Space>
          </div>
        </div>
      )}
    </>
  );
};

export default memo(UpdateAppWrapper);
